
import { Options, Vue, prop } from "vue-class-component";

class Props {
  regionName = prop<string>({
    type: String,
    default: "",
  });
  isStiDest = prop<boolean>({
    type: Boolean,
    default: false
  })
}

@Options({})
export default class STIIcon extends Vue.with(Props) {}
